import React from 'react'
import './CursorField.css'
import classnames from "classnames";
import ValidationUI from '../ValidationUI'

const CursorField = ({options, value, onChange, display,  disabled, touched, error, hasDetailedResponse, detailedResponse, detailedResponsePlaceholder, onResponseDetailsChange}) => {
    return (
        <div>
            <div className='Cursor-container'>
                {
                    options.map(option => {
                        return <input
                            key={option.id}
                            type='button'
                            className={classnames('Cursor-Button', {
                                selected: option.id === value.id,
                                disabledButton: disabled
                            })}
                            value={option[display]}
                            onClick={() => onChange(option)}
                            disabled={disabled}
                        />
                    })
                }
                {touched && (error && <ValidationUI error={error}/>)}
            </div>
            <div className="CursorField-textarea-container">
                {
                    hasDetailedResponse && <textarea
                        className="CursorField-textarea"
                        value={detailedResponse}
                        disabled={disabled}
                        placeholder={detailedResponsePlaceholder}
                        onChange={onResponseDetailsChange}
                        rows={3}
                    />
                }
            </div>
        </div>
    )
}


export default CursorField
